import { DuplicatePosition, Positions, QuantityPersonToTurn } from '../interfaces';

export const positions: Array<Positions> = [...Array(21)].map((_item: any, index) => ({
  value: index,
  label: String(index),
}));

export const duplicatePositon: Array<DuplicatePosition> = [
  {
    value: true,
    nome: 'Sim',
    codigo: 1,
  },
  {
    value: false,
    nome: 'Não',
    codigo: 2,
  },
];

export const quantityPersonToTurn: Array<QuantityPersonToTurn> = [
  {
    nome: '1',
    codigo: 1,
    value: 1,

  },
  {
    nome: '2',
    codigo: 2,
    value: 2,
  },
  {
    nome: '3',
    codigo: 3,
    value: 3,
  },
  {
    nome: '4',
    codigo: 4,
    value: 4,
  },
  {
    nome: '5',
    codigo: 5,
    value: 5,
  },
  {
    nome: '6',
    codigo: 6,
    value: 6,
  },
  {
    nome: '7',
    codigo: 7,
    value: 7,
  },
  {
    nome: '8',
    codigo: 8,
    value: 8,
  },
  {
    nome: '9',
    codigo: 9,
    value: 9,
  },
  {
    nome: 'Sem limite',
    codigo: 1000,
    value: 1000,
  },
];
